import {z} from '@hono/zod-openapi';

/** Comparable ads in stock and sold for the request vehicle. */
export const priceReportCountsResponseSchema = z
  .object({stock: z.number(), sold: z.number()})
  .openapi('PriceReportCountsResponse');
